module.exports = __webpack_public_path__ + "static/img/search-icon.1d04c11.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/search-icon.png
// module id = JPwo
// module chunks = 0